import { Component, OnInit } from '@angular/core';
import {ForgotPasswordService} from './forgot-password.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxMaskDirective } from 'ngx-mask';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import {getBaseUrl, getDatabase} from '../../environments/environment-functions';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatCardModule, MatInputModule, MatButtonModule, MatFormFieldModule, MatStepperModule, NgxSpinnerModule, NgxMaskDirective, MatIconModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(
    private service: ForgotPasswordService,
    private router: Router,
  ) { }

  public sendResetEmailForm: FormGroup = new FormGroup<any>({});
  public nextStepVerificationCode: boolean = false;
  public nextStepNewPassword: boolean = false
  public validateCodeForm: FormGroup = new FormGroup<any>({});
  public setNewPasswordForm: FormGroup  = new FormGroup<any>({});
  public hidePassword: boolean = true;
  public hideConfirmPassword: boolean = true;

  ngOnInit(): void {
    this.sendResetEmailForm = new FormGroup({
      documento: new FormControl('', [Validators.required])
    });
    this.validateCodeForm = new FormGroup({
      code: new FormControl('', [Validators.required])
    });
    this.setNewPasswordForm = new FormGroup({
      newPassword: new FormControl('', [Validators.required]),
      newPasswordConfirm: new FormControl('', [Validators.required]),
    });
    this.nextStepNewPassword = false;
    this.nextStepVerificationCode = false;
  }

  validateDocumentClick(): void{
    const documento = this.sendResetEmailForm.value.documento;
    this.validateEmail(documento);
  }

  validateEmailCode(): void {
    const documento = this.sendResetEmailForm.value.documento;
    const code = this.validateCodeForm.value.code;
    this.validateCode(documento, code);
  }

  changePassword(): void {
    const documento = this.sendResetEmailForm.value.documento;
    const code = this.validateCodeForm.value.code;
    const password = this.setNewPasswordForm.value.newPassword;
    const passwordConfirm = this.setNewPasswordForm.value.newPasswordConfirm;
    this.validatePasswordChange(documento, code, password, passwordConfirm);
  }

  /**
   * Faz o envio de e-mail para o solicitante
   */
  protected validateEmail(documento: string): void {
    this.service.showSpinner();
    this.service.sendEmailResetPassword(documento).subscribe((data) => {
      this.service.hideSpinner();
      this.service.toasterInfo('Verifique a sua caixa de e-mail', 'E-mail enviado!');
      this.nextStepVerificationCode = true;
    }, error => {
      this.service.hideSpinner();
      this.service.toasterWarning(error.error, 'Erro');
    });
  }

  /**
   *
   */
  protected validateCode(documento: string, code: string): void {
    this.service.showSpinner();
    this.service.validateCode(documento, code).subscribe((data) => {
      this.service.hideSpinner();
      this.service.toasterInfo('Código de verificação validado!');
      this.nextStepVerificationCode = true;
    }, (error) => {
      this.service.hideSpinner();
      this.service.toasterWarning(error.error ?? 'Houve um erro ao validar o código de verificação');
    });
  }

  protected validatePasswordChange(documento: string, code: string, password: string, confirmPassword: string): void {
    this.service.showSpinner();
    this.service.setNewPassword(documento, code, password, confirmPassword).subscribe((data) => {
      this.service.hideSpinner();
      this.service.toasterSuccess('Senha alterada com sucesso!');
      this.router.navigate(['login']);
    }, (err) => {
      this.service.hideSpinner();
      this.service.toasterWarning(err.error ?? 'Erro ao gravar nova senha');
    });
  }

  logo(): string {
    return getBaseUrl() + 'client_area/logo?database=' + getDatabase();
  }
}
